import type {NotificationVariant} from "./types";

let addNotificationRef:
  | ((message: string, variant: NotificationVariant) => string)
  | null = null;

export const registerToast = (
  addFn: (message: string, variant: NotificationVariant) => string,
) => {
  addNotificationRef = addFn;
};

const createHandler = (variant: NotificationVariant) => (message: string) => {
  if (!addNotificationRef) {
    throw new Error("Toast system not initialized");
  }
  return addNotificationRef(message, variant);
};

export const Toast = {
  success: createHandler("success"),
  error: createHandler("error"),
  warning: createHandler("warning"),
  info: createHandler("info"),
} as const;
